<template>
  <div class="section haze full-height">
    <div class="wrapper w-container">
      <div class="middle">
        <h5 class="green left">
          <strong>Step 1 of 3 | </strong><span><strong class="bold-text-2">Personal Information</strong></span>
        </h5>
      </div>
    </div>
    <div class="wrapper">
      <div class="contact-v1">
        <img
          v-if="isEditing"
          src="signUp/images/included-benefits-3.svg"
          alt=""
          class="icon biggest"
        >
        <div
          v-if="isEditing"
          class="intro"
        >
          <div class="text-label-2">
            No Problem, let&#x27;s get that updated
          </div>
          <h2 class="volk">
            Edit Information for {{ currentPatient.first_name.$model }}
          </h2>
          <div class="divider-2 animated" />
        </div>
        <div
          v-else
          class="intro"
        >
          <div class="text-label-2">
            {{ smallTitle }}
          </div>
          <h2 class="volk">
            {{ title }}
          </h2>
          <div class="divider-2 animated" />
        </div>
        <div class="full-width w-form">
          <form
            id="Contact-Form-1"
            name="email-form"
            data-name="Email Form"
            class="contact-form"
            autocomplete="on"
          >
            <div id="w-node-8ecf6d038dd7-9ede2a5a">
              <label for="fname">Name</label>
              <input
                id="fname"
                v-model="currentPatient.first_name.$model"
                type="text"
                class="input w-input"
                :class="{'inputError': currentPatient.first_name.$error }"
                maxlength="256"
                name="given-name"
                placeholder="John"
                autocomplete="given-name"
                @input="delayValidation"
              >
            </div>
            <div id="w-node-8ecf6d038ddb-9ede2a5a">
              <label for="lname">Last Name</label>
              <input
                id="lname"
                v-model="currentPatient.last_name.$model"
                :class="{'inputError': currentPatient.last_name.$error }"
                type="text"
                class="input w-input"
                maxlength="256"
                name="family-name"
                autocomplete="family-name"
                placeholder="Smith"
                required=""
                @input="delayValidation"
              >
            </div>
            <div id="w-node-dca5017474dd-9ede2a5a">
              <div class="w-layout-grid small-grid">
                <label for="bday">Birthdate</label><a
                  id="w-node-114c273ea1cf-9ede2a5a"
                  href="#"
                  class="lightbox-link-copy w-inline-block w-lightbox"
                  tabindex="-1"
                >
                  <img
                    src="signUp/images/why.svg"
                    alt=""
                    class="image-3"
                  >
                  <script
                    type="application/json"
                    class="w-json"
                  >
                  {
                    "items": [{
                      "type": "image",
                      "_id": "5ec84c77e3e7afedceb2f0d9",
                      "fileName": "why-birthdate.png",
                      "origFileName": "why-birthdate.png",
                      "width": 633,
                      "height": 1270,
                      "fileSize": 48682,
                      "url": "signUp/images/why-birthdate_1.png"
                    }]
                  }
                  </script>
                </a>
              </div><input
                id="bday"
                v-model="currentPatient.birth_date.$model"
                v-mask="birthdateMask"
                :class="{'inputError': currentPatient.birth_date.$error }"
                type="text"
                class="input w-input"
                maxlength="256"
                name="bday"
                data-name="bday"
                placeholder="MM/DD/YYYY"
                required=""
                @input="delayValidation"
              >
            </div>
          </form>
          <div class="form-success w-form-done">
            <div>Thank you! Your submission has been received!</div>
          </div>
          <div
            v-if="currentPatient.$error"
            class="form-error w-form-fail"
          >
            <div>Please correct the following error(s):</div>
            <div v-if="!currentPatient.first_name.required">
              First name is required.
            </div>
            <div v-else-if="!currentPatient.first_name.minLength">
              First name is too short.
            </div>
            <div v-if="!currentPatient.last_name.required">
              Last name is required.
            </div>
            <div v-else-if="!currentPatient.last_name.minLength">
              Last name is too short.
            </div>
            <div v-if="!currentPatient.birth_date.required">
              Birth date is required.
            </div>
            <div v-else-if="!currentPatient.birth_date.isDateValid">
              Invalid birth date.
            </div>
            <div v-else-if="!currentPatient.birth_date.maxValue">
              Birth date must not be greater than current date.
            </div>
            <div v-else-if="!currentPatient.birth_date.minValue">
              Birth date minimum value is 01/01/1920.
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mask } from 'vue-the-mask'

export default {
  name: 'Signup1Component',
  directives: { mask },
  props: {
    currentPatient: {
      type: Object,
      required: true,
      default: null
    },
    isEditing: {
      type: Boolean,
      default: false
    },
    patients: {
      type: Array,
      default: null
    }
  },
  data () {
    return {
      birthdateMask: '##/##/####'
    }
  },
  computed: {
    title () {
      if (this.patients.length >= 1 && !this.isEditing) {
        return 'Lets Add Another Member'
      } else {
        return 'Tell Us A Little About The Patient'
      }
    },
    smallTitle () {
      if (this.patients.length >= 1 && !this.isEditing) {
        return 'SAVE MONEY WITH MORE MEMBERS'
      } else {
        return 'LET\'S GET STARTED'
      }
    }
  },
  methods: {
    delayValidation () {
      this.currentPatient.$reset()
    }
  }
}
</script>
